module.exports = __webpack_public_path__ + "img/ugelli.e5871dc6.png";